import { Button, ButtonProps } from '@mui/material';
import { SxProps, Theme } from '@mui/material';

interface OutlinedButtonProps extends Omit<ButtonProps, 'sx' | 'variant'> {
  sx?: SxProps<Theme>;
}

export function OutlinedButton({ children, sx, ...props }: OutlinedButtonProps) {
  return (
    <Button
      variant="outlined"
      sx={{
        padding: '8px 16px',
        borderRadius: '6px',
        borderColor: '#D0D4D9',
        color: 'text.primary',
        fontSize: '16px',
        fontFamily: 'Inter',
        fontWeight: 500,
        lineHeight: '28px',
        textTransform: 'none',
        '&:hover': {
          borderColor: '#636B75',
          backgroundColor: 'transparent',
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
}
